import { SimNaoEnum } from 'components/form'

import { ExemplosVerticalFieldModel } from '../../components/ExemplosVerticalField'
import { PassouFalhouEnum } from '../../enums-consultaSeguimento'
import { ConsultaSeguimentoAplicacaoItemModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta11ExemplosEnum {
  SORRI_QUANDO_VOCE_SORRI = 'SORRI_QUANDO_VOCE_SORRI',
  SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO = 'SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO',
  SORRI_QUANDO_VOCE_VOLTA = 'SORRI_QUANDO_VOCE_VOLTA',
  ESTA_SEMPRE_SORRINDO = 'ESTA_SEMPRE_SORRINDO',
  SORRI_PARA_BRINQUEDO_OU_ATIVIDADE = 'SORRI_PARA_BRINQUEDO_OU_ATIVIDADE',
  SORRI_AO_ACASO_OU_SEM_MOTIVO = 'SORRI_AO_ACASO_OU_SEM_MOTIVO',
}

export interface ConsultaSeguimentoPergunta11Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_11_HEADER?: SimNaoEnum
  PERGUNTA_11_EXEMPLOS?: ExemplosVerticalFieldModel<ConsultaSeguimentoPergunta11ExemplosEnum>
  PERGUNTA_11_FREQUENCIA?: PassouFalhouEnum
}
